const LocationPin = ({ text }) => (
    <div className="pin">
      <i className="fa fa-map-marker map-pin"></i>
      <p className="pin-text">{text}</p>
    </div>
  );

  export default LocationPin;